import PaymentsConfirmOtpForm from './PaymentsConfirmOtpForm';

export default PaymentsConfirmOtpForm;
